<template>
    <v-dialog :fullscreen="isMobile" v-model="dialog" transition="slide-x-reverse-transition" max-width="600px"
              scrollable style="z-index: 10 !important;">
        <v-card :tile="isMobile" class="white-card">
            <v-app-bar color="white" flat>
                <v-spacer/>
                <div class="headline-heavy primary-color">
                    Previsualización de Orden
                </div>
                <v-spacer/>
                <v-btn icon @click="hide" color="primary">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-app-bar>

            <v-card-text class="pt-5" v-if="user">
                <order-preview
                    v-for="(order,i) in currentOrder" :key="order.title"
                    :class="[{'mb-3': i < currentOrder.length - 1}]"
                    :title="order.title"
                    :exams="order.exams"
                    :order="order"
                    :user="user"
                />
                <div class="text-center mt-6">
                    <v-alert v-if="withMessage && !isOrderOfCompany" class="message-text" color="primary" dark dense outlined v-html="message"/>
                    <small>
                        Esta orden es solo una previsualización y no posee ninguna valides legal ni médica.
                    </small>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import OrderPreview from "@/components/client/OrderPreview";

export default {
    name: "OrderDialog",
    components: {OrderPreview},
    props: {
        currentOrder: {
            type: Array,
            default: null
        },
        user: {
            type: Object,
            default: null
        },
        withMessage: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            dialog: false,
        }
    },
    computed: {
        message(vm = this) {
            let orderId = vm.currentOrder?.id || 'XXX'
            let laboratoryName = vm.currentOrder?.laboratory?.name || ''
            let laboratoryAddress = vm.currentOrder?.laboratory?.address || ''
            let laboratorySchedule = vm.currentOrder?.laboratory?.schedule || ''
            return `Su orden de examen ${orderId} ya se encuentra disponible en la toma de muestra de ${laboratoryName} en la dirección ${laboratoryAddress}.<br>
                Los horarios de atención son los siguientes:<br>
                ${laboratorySchedule}<br>
                A su llegada debe indicar nombre y rut al personal de atención.<br>
                Muchas gracias por su preferencia.`
        },
        isOrderOfCompany(vm = this) {
            return vm.currentOrder?.isCompany || false
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        }
    }
}
</script>

<style scoped>

>>> .v-dialog {
    border-radius: 16px;
}

.message-text {
    text-align: left;
    font-size: 13px;
    line-height: 14px;
}

</style>